import { render, staticRenderFns } from "./type-de-chauffage.vue?vue&type=template&id=2a42a865"
import script from "./type-de-chauffage.vue?vue&type=script&lang=js"
export * from "./type-de-chauffage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports